import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=2473fb1d&scoped=true&"
import script from "./Header.js?vue&type=script&lang=js&"
export * from "./Header.js?vue&type=script&lang=js&"
import style0 from "./Header.scss?vue&type=style&index=0&id=2473fb1d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2473fb1d",
  null
  
)

export default component.exports